"use client";
import { useState, useEffect } from "react";
import Image from "next/image";
import { Button } from "flowbite-react";


const Titleheading = () => {
    return (
        <div>
            <section className="parallex1 py-10 md:py-20 lg:py-40 -z-20 before:-z-10 before:bg-opacity-50" style={{ background: 'url("/images/plane-1.jpg")' }}>
                <div className="max-w-screen-xl mx-5 lg:mx-auto">
                    <div className="grid grid-cols-1 gap-3 items-center justify-between text-gray-300">
                        {/* <div className="">
                            <h1 className="font-bold text-white my-3">Contact Us</h1>
                            <p><a href="/" className="text-orange-600 hover:text-orange-300">Waveband Productions</a> / Contact Us</p>
                        </div> */}
                    </div>
                </div>
            </section>
        </div>
    );
};

export default Titleheading;